/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import LazyLoad from 'react-lazyload';

const LazyLoadComponent = (data) => {
    const { children, lazyload } = data;

    return <LazyLoad lazyload={lazyload}>{ children }</LazyLoad>;
};

export default LazyLoadComponent;
